//import { APISettings } from '../config.js';
import { useUserStore } from '@/stores/userStore.js';
import router from '../../router/index.js'

export default {
    name: "loginMethods",

    async login(obj) {
        var user = useUserStore();
        const response = await fetch("/backend/login", {
            method: 'POST',
            //mode: 'no-cors',
            body: JSON.stringify(obj)
        });
        if (!response.ok) {
            return (false);
        }
        else {
            const result = await response.json();
            const jwt = response.headers.get('Authorization');
            const jwtData = result.data;
            user.login(jwt, jwtData.username,jwtData.role);
            //router.push("/")
            if(result.messages[0].message == "refreshPassword"){
                return "refreshPassword";
            }
            return (true);
        }
    },
    logout() {
        var user = useUserStore();
        user.logout();
       // router.push("/login")
    },
    async createResetToken(obj){
        const response = await fetch("/backend/createResetToken", {
            method: 'POST',
            //mode: 'no-cors',
            body: JSON.stringify(obj)
        });
        if (!response.ok) {
            return (false);
        }
        else {
            const result = await response.json();
            let success;
            result.messages.forEach((e)=>{
                if(e.sender == "resetManager" && e.message == "success"){
                    success = true
                }
            })
            if(success){
                return (true);
            }
            return (false);
        }
    },
    async resetPassword(obj){
        const response = await fetch("/backend/resetPassword", {
            method: 'POST',
            //mode: 'no-cors',
            body: JSON.stringify(obj)
        });
        if (!response.ok) {
            return (false);
        }
        else {
            const result = await response.json();
            let success;
            result.messages.forEach((e)=>{
                if(e.sender == "resetManager" && e.message == "success"){
                    success = true
                }
            })
            if(success){
                return (true);
            }
            return (false);
        }
    }
}